import { getPageAndGlobalProps } from '@honeycomb/data';
import { GetServerSidePropsContext } from 'next';

// eslint-disable-next-line no-restricted-exports
export { default } from '../../hotels';
export async function getServerSideProps(context: GetServerSidePropsContext) {
    return getPageAndGlobalProps(context);
}
